"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapRootElement = void 0;
/** @jsx jsx */
var core_1 = require("@theme-ui/core");
var theme_provider_1 = require("@theme-ui/theme-provider");
var index_1 = __importDefault(require("./index"));
var Root = function (_a) {
    var children = _a.children;
    return (0, core_1.jsx)(theme_provider_1.ThemeProvider, { theme: index_1.default }, children);
};
var WrapRootElement = function (_a) {
    var element = _a.element;
    return (0, core_1.jsx)(Root, null, element);
};
exports.WrapRootElement = WrapRootElement;
